import { DSInput } from "@components/design-system/molecules";
import React from "react";
import {
  Controller,
  useFormContext,
  useFormState,
} from "react-hook-form";

import { isDateInputValid } from "./utils";

export function DateInput({ control }) {
  const { errors } = useFormState({ control });

  return (
    <div className="flex flex-col items-center space-x-2">
      <div
        className="flex flex-row space-x-2"
        data-testid="dateInput"
      >
        <DateInputPart
          name={"dd"}
          placeholder={"DD"}
          control={control}
          dataTestId="date-input-day"
        />
        <DateInputPart
          name={"mm"}
          placeholder={"MM"}
          control={control}
          dataTestId="date-input-month"
        />
        <DateInputPart
          name={"yyyy"}
          placeholder={"YYYY"}
          control={control}
          dataTestId="date-input-year"
        />
      </div>

      {errors.dd || errors.mm || errors.yyyy ? (
        <span className="text-xs text-danger text-center">
          This date is not valid. Please ensure you&apos;ve entered a
          valid, past date in the format of DD, MM, YYYY
        </span>
      ) : null}
    </div>
  );
}

function DateInputPart({
  control,
  name,
  placeholder,
  dataTestId = null,
}) {
  const { getValues } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        validate: {
          dateValidation: () => {
            const { dd, mm, yyyy } = getValues();
            return isDateInputValid({
              dd,
              mm,
              yyyy,
            });
          },
        },
      }}
      render={({ field }) => (
        <DSInput
          placeholder={placeholder}
          dataTestId={dataTestId ?? name}
          {...field}
        />
      )}
    />
  );
}
